import { render, staticRenderFns } from "./PracticeItem.vue?vue&type=template&id=3591d0c3&scoped=true&"
import script from "./PracticeItem.vue?vue&type=script&lang=js&"
export * from "./PracticeItem.vue?vue&type=script&lang=js&"
import style0 from "./PracticeItem.vue?vue&type=style&index=0&id=3591d0c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3591d0c3",
  null
  
)

export default component.exports